import once from 'lodash/once';
import { SUBSCRIPTION_FORM_OPEN } from '../../config/events';
import { ACTION_TYPE } from '../../config/constants';
import on from '../dom/on';
import onLinkClick from '../dom/on-link-click';
import trackAppInstall from '../track-event/install';



const trackAppInstallOnce = once(trackAppInstall);

export default (element, install_action_type, component, eventProps = null) => {
  if (install_action_type === ACTION_TYPE.DIRECT_LINK_INSTALL) {
    return [
      onLinkClick(element, (ev, done) => {
        trackAppInstallOnce(eventProps, done);
      })
    ];
  }

  return [
    on(element, 'click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      trackAppInstallOnce();
      component.$emit(SUBSCRIPTION_FORM_OPEN);
    })
  ];
};



// WEBPACK FOOTER //
// ./src/lib/bind-event-tracking/subscribe-install-btn.js